import { render, staticRenderFns } from "./BusinessLocation.vue?vue&type=template&id=646c0908&scoped=true&"
import script from "./BusinessLocation.vue?vue&type=script&lang=js&"
export * from "./BusinessLocation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLocation.vue?vue&type=style&index=0&id=646c0908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c0908",
  null
  
)

export default component.exports